var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseComment24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.524 5.457a.758.758 0 0 1 .985-.062.577.577 0 0 1 .07.878l-4.06 4.183a.738.738 0 0 1-.53.215.735.735 0 0 1-.527-.216L7.42 6.272a.578.578 0 0 1 .074-.879.758.758 0 0 1 .984.066l3.514 3.636 3.533-3.638Zm0 13.571c.253.26.694.288.985.062a.577.577 0 0 0 .07-.878l-4.06-4.183a.738.738 0 0 0-.53-.215.736.736 0 0 0-.527.217L7.42 18.214a.578.578 0 0 0 .074.878.758.758 0 0 0 .984-.066l3.514-3.636 3.534 3.638Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseComment24);
export default __webpack_public_path__ + "static/media/collapse_comment_24.94ba17e952d20ba561265824ebf57662.svg";
export { ForwardRef as ReactComponent };